<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
      @hide="$emit('hide')"
    />
    <AnalyticsWrapper>
      <div :class="layoutClasses">
        <div
          v-if="label || description"
          class="formester-label-description-wrapper"
          :style="labelDescriptionWrapperStyles"
        >
          <label
            :class="labelClasses"
            :style="labelStyles"
            :for="item.label + item.id"
            v-html="label"
          />
          <SmartText
            :active="active"
            :editing="editing"
            :item="item"
            :style="descriptionStyles"
            :text="description"
          />
        </div>

        <textarea
          :id="item.label + item.id"
          v-model="itemValue"
          :readonly="editing"
          :data-uuid="item.id"
          :class="inputClasses"
          :style="inputStyles"
          :placeholder="item.placeholder"
          :name="item.label"
          :rows="item.rows"
          style="height: 100%"
          :required="item.required"
          :minlength="item.minimum"
          :maxlength="item.maximum"
          :disabled="isDisabled"
        />
        <ErrorMessage :item="item" />
      </div>
    </AnalyticsWrapper>
  </div>
</template>

<script>
import ElementControls from "./element-controls.vue";
import commonStyles from "./mixins/commonStyles";
import sharedActions from "./mixins/sharedActions";
import ErrorMessage from "./error-message.vue";
import setItem from "lodash/set";
import SmartText from "./shared/smart-text.vue";
import AnalyticsWrapper from "./analytics-wrapper.vue";

export default {
  name: "LongText",
  components: {
    ElementControls,
    ErrorMessage,
    SmartText,
    AnalyticsWrapper,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      required: true,
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate", "hide"],
  computed: {
    itemValue: {
      get() {
        return this.item.value;
      },
      set(e) {
        setItem(this.item, "value", e);
      },
    },
    inputClasses() {
      return {
        "formester-input": true,
        "formester-input__longtext": true,
        "dragField-textarea": true,
      };
    },
  },
};
</script>

<style scoped>
.formester-input.formester-input__longtext {
  height: auto;
  padding: 10px 10px;
  width: 100%;
  resize: vertical;
  max-height: 350px;
  min-height: 50px;
}
</style>
